function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@material-ui/core';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { Block } from '../content';
const TextBox = ({
  value,
  controlled = false,
  endAdornmentText,
  required,
  minLength,
  maxLength,
  email,
  readOnly,
  customRef = false,
  onChange,
  onBlur,
  error,
  xs,
  md,
  lg,
  margin = 'normal',
  minValue,
  maxValue,
  forceError,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const [errorMessage, setErrorMessage] = useState(error);
  const [localDefaultValue, setLocalDefaultValue] = useState(value);
  const requiresValidation = required || minLength || maxLength || email || minValue || maxValue;
  rest.inputProps = {
    requiredstr: required ? 'true' : 'false',
    minlengthval: minLength,
    maxlengthval: maxLength,
    min: minValue,
    max: maxValue,
    emailval: email ? 'true' : 'false',
    step: rest.step && rest.step,
    ...rest.inputProps
  };
  let ref;
  if (!customRef) {
    ref = requiresValidation && /*#__PURE__*/React.createRef();
  } else {
    ref = customRef;
  }
  const onBlurHandler = event => {
    setErrorMessage(null);
    setLocalDefaultValue(event.target.value);
    onBlur && onBlur(event.target.value);
  };
  const onChangeHandler = event => {
    onChange && onChange(event.target.value, event);
  };
  useEffect(() => {
    const validationListener = event => {
      // console.log('EVENT', event);
      event.stopPropagation();
      setErrorMessage(t(event.target.errormsg).replace('[nome]', rest.label).replace('[errormsgparam]', event.target.errormsgparam));
      setLocalDefaultValue(event.target.value);
    };
    if (!customRef) {
      const node = ref && ref.current;
      node && node.addEventListener('invalid-data', validationListener);
      return () => {
        node && node.removeEventListener('invalid-data', validationListener);
      };
    }
  }, [ref, rest.label, t, customRef]);
  if (endAdornmentText) {
    rest.InputProps = {
      ...rest.InputProps,
      endAdornment: /*#__PURE__*/React.createElement(InputAdornment, {
        position: "end"
      }, endAdornmentText)
    };
  }
  if (readOnly) {
    rest.inputProps.readOnly = readOnly;
  }
  if (errorMessage || forceError && error) {
    rest.error = true;
    rest.helperText = errorMessage || error;
  }
  if (!xs && !md) {
    rest.margin = margin;
  }

  // `controlled` opts into a fully-controlled TextField (value from the caller on
  // every render) instead of the legacy defaultValue/blur-sync behavior — needed by
  // reducer-driven forms (e.g. AI Studio 2 wizards) that reset/prefill programmatically.
  const valueProps = controlled ? {
    value: value === undefined || value === null ? '' : value
  } : {
    defaultValue: localDefaultValue === undefined || localDefaultValue === null ? '' : localDefaultValue
  };
  const content = /*#__PURE__*/React.createElement(TextField, _extends({
    variant: "outlined",
    color: "secondary"
  }, valueProps, {
    onBlur: onBlurHandler,
    onChange: onChangeHandler,
    inputRef: !customRef ? ref : customRef
  }, rest));
  if (xs || md || lg) {
    let marginProps;
    if (margin === 'normal') {
      marginProps = {
        margin: 4,
        marginBottom: 2
      };
    } else if (margin === 'none') {
      marginProps = {
        margin: 0
      };
    } else {
      marginProps = {
        margin
      };
    }
    return /*#__PURE__*/React.createElement(Block, _extends({
      xs: xs,
      md: md,
      lg: lg
    }, marginProps, {
      style: {
        overflowY: 'visible'
      }
    }), content);
  }
  return content;
};
TextBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  onBlur: PropTypes.func,
  endAdornmentText: PropTypes.any,
  autoComplete: PropTypes.string,
  id: PropTypes.string
};
export default TextBox;